import { MethodInstall } from "../../utils";
import Notify from "./src/index.js";

export default MethodInstall(Notify, "Notify");
